import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { setAzureAccessToken } from '@app/state/actions/app.action';
import { MsalService } from '@azure/msal-angular';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root', // 💡 This tells Angular to provide this service app-wide
})
export class AuthService {
  store = inject(Store);
  msalService = inject(MsalService);
  router = inject(Router);

  logout(): void {
    const account = this.msalService.instance.getActiveAccount();
    if (account) {
      // this.msalService.instance.clearCache();
    }
    // this.msalService.instance.setActiveAccount(null);

    this.store.dispatch(setAzureAccessToken({ accessToken: null, idToken: null }));
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('idToken');

    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  }
}
